import queryClient from '@/utils/queryClient'
import { type Updater, useQuery } from '@tanstack/react-query'

export const IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY = ['IS_NOTI_ALLOWED']
export function getIsNotiAllowed() {
	return queryClient.getQueryData<boolean>(IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY)
}
export function setIsNotiAllowed(updater: Updater<boolean, boolean>) {
	return queryClient.setQueryData<boolean>(
		IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY,
		updater as Updater<boolean | undefined, boolean | undefined>
	)
}
export function useIsNotiAllowed() {
	const { data } = useQuery<boolean>({
		queryKey: IS_NOTI_ALLOWED_QUERY_OPTIONS_KEY,
		initialData: 'Notification' in window && globalThis.Notification.permission === 'granted',
	})
	return [data, setIsNotiAllowed] as const
}
